module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1028-e958dc742bed8e730ae425f10027348d.png";